export default "__VITE_ASSET__LRI3$dWX__"